import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import { useEquipment, useUser } from "@services/servicesGenericsTables";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

const MeasurementBRBT = () => {
  const { watch, setValue, getValues } = useFormContext();
  const { currentMeasurement } = useAnalysis();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const filteredProcedures = useFilteredProcedures("AA");
  const aaEquipmentResult = watch("measurement_aa_equipment_result") || 0;
  const dilutionFactor = watch("measurement_dilution_factor") || 0;

  const unitTypes = watch("analysis_unit_types")?.descripcion;
  const amountSample = watch("analysis_amount_sample");
  const resultToCalculation = watch("measurement_result_to_calculation") || 0;

  useEffect(() => {
    const result = parseFloat(aaEquipmentResult) * parseFloat(dilutionFactor);

    if (!isNaN(result)) {
      setValue("measurement_result_to_calculation", result);
    } else {
      setValue("measurement_result_to_calculation", "0.000");
    }
  }, [aaEquipmentResult, dilutionFactor, setValue]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const parsedResult = parseFloat(resultToCalculation);
    const parsedAmount = parseFloat(amountSample);

    if (isNaN(parsedResult) || isNaN(parsedAmount)) {
      setValue("measurement_mg_potasio", "0.000");
      return;
    }

    let mgPotasio = 0;

    if (unitTypes === "Bq/m3") {
      mgPotasio = parsedResult * parsedAmount * 1000;
    } else if (unitTypes === "Bq/L" || unitTypes === "Bq/Kg") {
      mgPotasio = parsedResult * parsedAmount;
    } else if (unitTypes === "Bq/g") {
      mgPotasio = (parsedResult * parsedAmount) / 1000;
    }

    setValue("measurement_mg_potasio", mgPotasio);
  }, [unitTypes, amountSample, resultToCalculation]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {currentMeasurement.index !== undefined ? (
        <React.Fragment key={currentMeasurement.id}>
          <ResponsiveFormContainer columns={4}>
            <MAutocomplete
              name="measurement_analyst"
              options={userList}
              label="Seleccione un analista"
              getOptionLabel={(option) => option.username || ""}
              validation={{ required: "El analista es requerido" }}
              disabled={!currentMeasurement.canEdit}
            />
            <MAutocomplete
              key={JSON.stringify(getValues("measurement_procedure"))}
              name="measurement_procedure"
              options={filteredProcedures}
              label="Procedimiento MLPMA"
              getOptionLabel={(option) => `${option.numop}` || ""}
              /* validation={{ required: "El procedimiento es requerido" }} Agregar cuando se conecte a base de datos*/
              disabled={!currentMeasurement.canEdit}
            />
            <MDatePicker
              key="measurement_start_date_time"
              name="measurement_start_date_time"
              pickerType="datetime"
              label="Fecha de inicio"
              disabled={!currentMeasurement.canEdit}
            />
            <MAutocomplete
              key={JSON.stringify(getValues("equipment"))}
              name="measurement_equipment"
              options={equipmentList}
              label="Equipos/ geometría"
              getOptionLabel={(option) =>
                `${option.codigo} - ${option.descripcion}` || ""
              }
              validation={{ required: "El equipo es requerido" }}
              multiple={true}
              disabled={!currentMeasurement.canEdit}
            />
            <MTextField
              name="measurement_dilution_factor"
              label="Factor de dilución"
              placeholder="Factor de dilución"
              type="number"
              validation={{ required: "El factor de dilución es obligatorio" }}
              fullWidth
              step={0.01}
              disabled={!currentMeasurement.canEdit}
            />
            <MTextField
              name="measurement_aa_equipment_result"
              label="Resultado equipo AA (mg/l)"
              placeholder="Resultado equipo AA (mg/l)"
              type="number"
              validation={{ required: "El resultado equipo AA es obligatorio" }}
              fullWidth
              step={0.01}
              disabled={!currentMeasurement.canEdit}
            />
            <MTextField
              name="measurement_result_to_calculation"
              label="Resultado final"
              placeholder="Resultado final"
              type="number"
              fullWidth
              step={0.01}
              disabled
            />
            <MTextField
              name="measurement_mg_potasio"
              label="mg de Potasio"
              placeholder="mg de Potasio"
              type="number"
              fullWidth
              step={0.01}
              disabled
            />
          </ResponsiveFormContainer>
        </React.Fragment>
      ) : null}
    </>
  );
};

export default MeasurementBRBT;
